import React from "react";

interface PageTitleProps {
  groupName: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ groupName }) => {
  // Function to capitalize first letter of a string
  const capitalizeFirstLetter = (str: string) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <div className="view-header">
      <div className="view-content row page-category__header">
        <div className="page-category__title">
          <div className="views-field-name">
            <h1>{capitalizeFirstLetter(groupName)}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};
